export const _themes = Object.freeze([
    { color: '#f75c48', class: 'orange' },
    // { color: '#009BAF', class: 'teal' },
    { color: '#21A019', class: 'green' },
    { color: '#497EF7', class: 'blue' },
    { color: '#BA5DF2', class: 'purple' },
    // { color: '#858600', class: 'lime' },
    // { color: '#FE5298', class: 'pink' },
]);
